import { Vue, MsgBox } from '../../app.vues'

import statisFieExpl from './statisFieExpl';
Vue.regist(statisFieExpl);


export function showStatisFieExplDlg(theme) {
    //
    Vue.$showDialog({
        title: '统计字段说明',
        width: 800,
        height: 600,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template:
        '<swb-statis-fie-expl :theme="theme"></swb-statis-fie-expl>' ,
        data: {
            theme: theme
        },
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/compo/statisWork/statisDig.js
// module id = 150
// module chunks = 0